/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Online_DescInputs */

const en_vc_page_online_desc = /** @type {(inputs: Vc_Page_Online_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use VectorCraft online for free: the open-source Illustrator alternative running in your browser through WebAssembly. No sign-up, no install, and your files never leave your computer.`)
};

const zh_vc_page_online_desc = /** @type {(inputs: Vc_Page_Online_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线使用 VectorCraft：这款开源的 Illustrator 替代品通过 WebAssembly 直接在浏览器中运行。无需注册、无需安装，文件不会离开你的电脑。`)
};

/**
* | output |
* | --- |
* | "Use VectorCraft online for free: the open-source Illustrator alternative running in your browser through WebAssembly. No sign-up, no install, and your files ..." |
*
* @param {Vc_Page_Online_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_online_desc = /** @type {((inputs?: Vc_Page_Online_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Online_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_online_desc(inputs)
	return zh_vc_page_online_desc(inputs)
});
export { vc_page_online_desc as "vc.page.online.desc" }